import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetFixture, successGetFixture } from './FixtureSlicer';
import { ISlotList } from '../../../Pages/Slot/ISlot';
import { PayloadAction } from '@reduxjs/toolkit';
import { failureAddFixture, successAddFixture } from './AddFixtureSlicer';
import {
  failureUpdateFixture,
  successUpdateFixture,
} from './UpdateFixtureSlicer';
import {
  failureDeleteFixture,
  successDeleteFixture,
} from './DeleteFixtureSlice';
import { Phone } from '@mui/icons-material';
import {
  failureUpdateFixtureOrder,
  successUpdateFixtureOrder,
} from './UpdateFixtureOrderSlicer';

const FixtureApi = (action: PayloadAction<any>) => {
  return api.get(`fixtures/${action.payload}`);
};

export function* FixtureCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(FixtureApi, action);
    yield put(successGetFixture(response.data));
  } catch (error) {
    yield put(failureGetFixture(error));
  }
}

// add Fixture
const AddFixtureApi = (action: PayloadAction<ISlotList>) => {
  // const data = {
  //   level_id: action.payload.level_id,
  //   level_diagram: action.payload.level_diagram,
  //   status: action.payload.status,
  //   location_id: action.payload.location_id,
  // };

  // return api.post('/levels/create', data);

  return api.post('/fixtures/create', action.payload);
};

export function* AddFixtureCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(AddFixtureApi, action);
    yield put(successAddFixture(response.data));
  } catch (error) {
    yield put(failureAddFixture(error));
  }
}
//updateorderfixture
const UpdateFixtureOrderApi = (action: PayloadAction<ISlotList>) => {
  console.log('updat order');

  return api.patch('/fixtures/updateFixtureOrders', action.payload);
};

export function* UpdateFixtureOrderCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(UpdateFixtureOrderApi, action);
    yield put(successUpdateFixtureOrder(response.data));
  } catch (error) {
    console.log(error);

    yield put(failureUpdateFixtureOrder(error));
  }
}

// update Fixture
const UpdateFixtureApi = (action: PayloadAction<ISlotList>) => {
  const data = {
    level_id: action.payload.level_id,
    fixture_id: action.payload.fixture_id,
    fixture_ip_address: action.payload.fixture_ip_address,
    status: action.payload.status,
    location_id: action.payload.location_id,
    aisle_id: action.payload.aisle_id,
    group_id: action.payload.group_id,
  };

  const url = `/fixtures/${action.payload.id}`;

  return api.put(url, data);
};

export function* UpdateFixtureCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(UpdateFixtureApi, action);
    yield put(successUpdateFixture(response.data));
  } catch (error) {
    yield put(failureUpdateFixture(error));
  }
}

// delete Fixture
const DeleteFixtureApi = (action: PayloadAction<number>) => {
  return api.delete(`/fixtures/${action.payload}`);
};
export function* DeleteFixtureCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteFixtureApi, action);
    yield put(successDeleteFixture(response.data));
  } catch (error) {
    yield put(failureDeleteFixture(error));
  }
}
